import { withRouter } from 'react-router';
import { WhatsNewSection, HomepageSectionHeader, Image, Card} from 'dma-ui-kit';

const HomePageNewsWidget = props => {

    const { history } = props;
    const { field_title_light, field_title_bold, field_subtitle, field_cta_link } = props.paragraph.attributes;

    // Due to how Drupal handles internal urls, strip garbage
    const ctaLink = field_cta_link.uri.replace('internal:', '');
    const followCTA = () => { history.push(ctaLink); };
    
    const promotedNewsItems = [];

    return (
        <>
            <WhatsNewSection
                header={
                    <HomepageSectionHeader
                        boldHeadline={field_title_bold}
                        lightHeadline={field_title_light}
                        description={field_subtitle}
                        action={followCTA}
                        actionLabel={field_cta_link.title}
                    />
                }
            >
                {promotedNewsItems}
            </WhatsNewSection>
        </>
    );
};

export default withRouter(HomePageNewsWidget);
